import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrisDager, SpotprisResponse } from './spot.types';
import { theTime } from 'src/app/utils/date-utils';

@Injectable({
  providedIn: 'root'
})
export class SpotService {
  constructor(private _httpClient: HttpClient) { }

  getDagspot(dato: Date): Observable<SpotprisResponse> {
    const url =
      'https://apiprivat.ishavskraft.no/forbruk/spotpris/mnd/' +
      theTime(dato).toPlainDateString();
    return this._httpClient.get<SpotprisResponse>(url);
  }

  getTimespot(dato: Date): Observable<SpotprisResponse> {
    return this._httpClient.get<SpotprisResponse>(
      'https://apiprivat.ishavskraft.no/forbruk/spotpris/dag/' +
      theTime(dato).toPlainDateString()
    );
  }

  getSpotRange(start: Date, end: Date): Observable<PrisDager[]> {
    return this._httpClient.get<PrisDager[]>(
      'https://api.servicekanal.no/spotpriser/fradatotildato/' +
      theTime(start).toPlainDateString() +
      '/' +
      theTime(end).toPlainDateString()
    );
  }
}
